// dashboard.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { EditDashboardComponent } from '@pages/dashboard/edit/edit-dashboard.component';
import { JobDashboardComponent } from '@pages/dashboard/job-dashboard/job-dashboard.component';
import { WorkerDashboardComponent } from '@pages/dashboard/worker-dashboard/worker-dashboard.component';
import { Environment, NimmstaCommonsModule, ServiceType } from '@nimmsta/ng-commons-lib';
import { environment } from '@environments/environment';
import { AccordionModule } from 'primeng/accordion';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { CardBarComponent } from '@components/card-bar/card-bar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { JobDashboardFormComponent } from './job-dashboard/job-dashboard-form.component';
import { WorkerDashboardFormComponent } from './worker-dashboard/worker-dashboard-form.component';
import { DashboardFormWrapperComponent } from './edit/dashboard-form-wrapper.component';
import { SmartwatchDashboardComponent } from './smartwatch-dashboard/smartwatch-dashboard.component';
import { SmartwatchDashboardFormComponent } from './smartwatch-dashboard/smartwatch-dashboard-form.component';
import { WorkflowDashboardComponent } from './workflow-dashboard/workflow-dashboard.component';

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardFormWrapperComponent,
    EditDashboardComponent,
    JobDashboardComponent,
    JobDashboardFormComponent,
    SmartwatchDashboardComponent,
    SmartwatchDashboardFormComponent,
    WorkerDashboardComponent,
    WorkerDashboardFormComponent,
    WorkflowDashboardComponent,
    WorkerDashboardFormComponent,
    CardBarComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    BsDatepickerModule,
    AccordionModule,
    SelectModule,
    MultiSelectModule,
    InputGroupModule,
    InputGroupAddonModule,
    ButtonModule,
    RouterModule,
    ReactiveFormsModule,
    NimmstaCommonsModule.forRoot({
      environment: environment.environment as Environment | undefined,
      serviceType: ServiceType.CLOUD,
      apiUrls: environment.apiUrls,
      applicationUrls: environment.applicationUrls,
      defaultPageSizeOptions: environment.defaultPageSizeOptions,
      defaultPageSize: environment.defaultPageSize,
      USER_KEY: environment.USER_KEY,
      keycloakUrl: environment.keycloakUrl,
      keycloakRealm: environment.keycloakRealm,
      keycloakClientId: environment.keycloakClientId,
      defaultConfigurationVersion: environment.defaultConfigurationVersion,
      androidAppSoftwareId: environment.androidAppSoftwareId,
      translationFiles: ['./assets/i18n/commons/', './assets/i18n/b2b/', './assets/i18n/workflow/', './assets/i18n/'],
      // eslint-disable-next-line max-len
      maintenanceInfoSource: 'assets/maintenance/cloud-maintenance.json',
    }),
  ],
  exports: [DashboardComponent, EditDashboardComponent, JobDashboardComponent, WorkerDashboardComponent],
})
export class DashboardModule {}
